module.exports = __webpack_public_path__ + "img/logo_sp.025659f9.png";